import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import Translate from "../../common/translate/Translate";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import CustomInput from "../../common/components/input/CustomInput";
import { useState } from "react";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import LanguageSelector from "./components/LanguageSelector";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import { Theme } from "../../common/Theme";
import LMPAuthUtils from "../../api/lmp/LMPAuthUtils";

const countryValues = [
    { label: "South Korea", value: "KR" },
    { label: "Vietnam", value: "VN" },
    { label: "Indonesia", value: "ID" },
    { label: "Australia", value: "AU" },
    { label: "Cambodia", value: "KH" },
    { label: "Sri Lanka", value: "LK" },
    { label: "Malaysia", value: "MY" },
    { label: "Nepal", value: "NP" },
    { label: "New Zealand", value: "NZ" },
    { label: "Philippines", value: "PH" },
    { label: "Singapore", value: "SG" },
    { label: "Hong Kong", value: "HK" },
    { label: "Taiwan", value: "TW" },
    { label: "China", value: "CN" },
    { label: "India", value: "IN" },
    { label: "Thailand", value: "TH" },
    { label: "Japan", value: "JP" },
];

function InitPage() {
    const [serverCountry, setServerCountry] = useState("TH");

    function handleChangeServerCountry(v) {
        setServerCountry(v);
    }

    function handleSelect() {
        localStorage.setItem(LocalStorageKey.server, serverCountry);
        window.location.href = LMPAuthUtils.getLoginUrl({ serverCountry });
    }

    return (
        <AuthContentWrapper contentPadding={"62px 64px"} overflowY={"visible"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    {Translate("common.laundryCrew")} {Translate("role.admin")}
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>{Translate("auth.selectCountry")}</C2Text>
                <SizedBox height={"44px"} />
            </Column>
            <LanguageSelector />
            <SizedBox height={"20px"} />
            <CustomInput
                padding={"15px 16px"}
                type={"select"}
                dropdownValues={countryValues}
                inputValue={serverCountry}
                setInputValue={handleChangeServerCountry}
                noBlur={true}
            />
            <SizedBox height={"20px"} />
            <FullWidthButton onClick={handleSelect} text={"Select"} />
        </AuthContentWrapper>
    );
}

export default InitPage;
